import { Box as MuiBox } from '@mui/material';
import './Box.scss';

interface BoxProps {
  variant?: 'default' | 'shadow';
  children: React.ReactNode;
}

/**
 * Primary UI component for user interaction
 */
export const Box = ({ variant = 'default', ...props }: BoxProps) => {
  return <MuiBox className={`${variant} box-style`}>{props.children}</MuiBox>;
};
